/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Helpers.
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';

import { trackLink, trackPage } from '../../lib/analytics-helper';

// Constants
import * as homeShape from '../constants/PropTypesShapes';
import { getBNATitle } from '../../lib/messageHelper';

// Actions.
import { updateBnaData } from '../actions/action-update-bna-data';

// Containers
import InteractiveGuide from './InteractiveGuideContainer';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../lib/experiments-helper';

const BNAChannel = 'BNA';

const PopularArticles = (props) => {
  const { articles, error, updateBnaData: updateBna, treatments } = props;
  const popular = {
    common: i18n.message('smarthelp/home.home.common'),
    recommended: i18n.message('smarthelp/home.home.recommended'),
    errorMessage: i18n.message('smarthelp/Error.error.popular'),
    recommendedTile: i18n.message('smarthelp/contactOption.recommend'),
  };

  const goToArticlePage = (currentArticle) => {
    let link = `smarthelp-common-questions|${currentArticle.articleId}`;

    if (currentArticle.channel === BNAChannel) {
      updateBna(currentArticle);
      link = `${link}|${BNAChannel}`;
    }

    trackLink({ id: 'homePage', link });
  };

  const handleKeyPress = (event, article) => {
    if (event.which === 13) {
      goToArticlePage(article);
    }
  };

  const renderPromptICF = (listItems) => {
    if (isPartOfElmoExpTreatment(treatments, elmoTreatmentNames.treatmentforIcfTop)) {
      trackPage({ id: 'ICFGuide', link: 'smarthelp-home-icf-top' });
      return (
        <div>
          <InteractiveGuide />
          <div className="popular-questions"><ul>{listItems}</ul></div>
        </div>
      );
    } else if (isPartOfElmoExpTreatment(treatments, elmoTreatmentNames.treatmentForIcfDown)) {
      trackPage({ id: 'ICFGuide', link: 'smarthelp-home-icf-down' });
      return (
        <div>
          <div className="popular-questions"><ul>{listItems}</ul></div>
          <InteractiveGuide />
        </div>
      );
    }
    return <div className="popular-questions"><ul>{listItems}</ul></div>;
  };

  // Common function to get parsed article item.
  const getParsedArticleListItem = article => (<li key={article.articleId} className="popular-title-list">
    <a
      className="popular-item"
      href={Page.getFullArticleURL(article)}
      onClick={() => goToArticlePage(article)}
      onKeyPress={event => handleKeyPress(event, article)}
    >
      {article.articleTitle}
    </a>
  </li>);

  /**
   * Render BNA articles section only if BNA articles exists.
   *
   * @param bnaArticles
   * @returns - BNA Section HTML code
   */
  const renderBnaSection = (bnaArticles) => {
    if (Array.isArray(bnaArticles) && bnaArticles.length) {
      const listItems = bnaArticles.map(article => getParsedArticleListItem(article));
      return (<div>
        <div className="pcc-user-recommended-title">
          <h1 className="popular-title">{getBNATitle()}</h1>
          <span className="pp-vx-sh-tag pp-vx-sh-tag--success">{popular.recommendedTile}</span>
        </div>
        {renderPromptICF(listItems)}
      </div>);
    }
    return null;
  };

  /**
   * Render FAQ section
   *
   * @param faqArticles
   * @returns - FAQ section HTML code
   */
  const renderFaqSection = (faqArticles) => {
    if (Array.isArray(faqArticles) && faqArticles.length) {
      const listItems = faqArticles.map(article => getParsedArticleListItem(article));
      return (<div>
        <h1 className="popular-title">{ popular.common}</h1>
        <div className="popular-questions">
          <ul>{listItems}</ul>
        </div>
      </div>);
    }
    return null;
  };


  const renderContents = () => {
    if (error) {
      return <div className="popular-error">{popular.errorMessage}</div>;
    }

    Page.setCanonicalTag({ name: 'home' });

    if (Array.isArray(articles) && articles.length > 0) {
      const BnaArticles = articles.filter(article => article.channel === BNAChannel);
      const faqArticles = articles.filter(article => article.channel !== BNAChannel);

      if (Page.isLoggedIn()) {
        return (<div>
          {renderBnaSection(BnaArticles)}
          {renderFaqSection(faqArticles)}
        </div>);
      }
      return renderFaqSection(articles);
    }
    return null;
  };

  return (
    <div className="popular-articles popular-articles__grid">
      {renderContents()}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    articles: state.popular.articles,
    error: state.popular.error,
    treatments: state.app.elmoTreatments,
  };
}
PopularArticles.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape(homeShape.POPULAR_ARTICLE)),
  error: PropTypes.bool,
  treatments: PropTypes.string.isRequired,

  // Method Prop Types.
  updateBnaData: PropTypes.func.isRequired,
};

PopularArticles.defaultProps = {
  articles: [],
  error: false,
};

// Dispatch the Action as Props.
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBnaData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularArticles);
